import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { Viewable } from "scene-manager";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { PromiseCompletionSource } from "scene-manager";
import { AdView } from "./view/AdView";

@injectable()
export class AdScene extends Viewable<boolean> {
    public constructor(
        @inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler
    ) {
        super();
    }

    @initializer()
    public async initialize(): Promise<void> {
        const viewCanBeClosed = new PromiseCompletionSource<boolean>();
        this.view = new AdView(this.canvasScaler, viewCanBeClosed);
        viewCanBeClosed.result.then(this.operationControls.complete);
    }
}